import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex w-full justify-between pb-2 md:flex-wrap" }
const _hoisted_2 = { class: "hidden w-full flex-wrap items-center md:flex md:w-auto md:flex-nowrap" }
const _hoisted_3 = { class: "flex w-full flex-wrap sm:flex-nowrap sm:space-x-2 md:mr-2" }
const _hoisted_4 = { class: "mr-2 md:hidden" }
const _hoisted_5 = {
  key: 1,
  class: "fixed bottom-0 left-0 z-50 w-full rounded-t-3xl bg-white p-4 shadow-2xl"
}
const _hoisted_6 = { class: "flex items-center justify-between p-4" }
const _hoisted_7 = { class: "scrollbar-hide max-h-[75vh] overflow-scroll px-4" }

import { computed, ref } from "vue";
import { storeToRefs } from "pinia";

import { getTranslation, getGlobalTranslation } from "~/js/composables/translations";
import { getHtmlSpecialCharsDecode } from "~/js/composables/parse-html";

import { Translations } from "~/js/interfaces/translations";
import { Category } from "~/js/interfaces/knowledge-hub";
import { Facet, FacetCount } from "~/js/interfaces/facets";

import { useFileManagerStore } from "~/js/store/file-manager";

// import FilterCheckbox from '~/vue/molecules/filters/FilterCheckbox.vue'
// import FilterCheckboxMobile from '~/vue/molecules/filters/FilterCheckboxMobile.vue'
import FilterMultiselect from "~/vue/molecules/filters/FilterMultiselect.vue";
import FilterConsent from "~/vue/molecules/filters/FilterConsent.vue";
import FilterMultiselectMobile from "~/vue/molecules/filters/FilterMultiselectMobile.vue";
import FilterSearch from "~/vue/molecules/filters/FilterSearch.vue";
import ButtonFilterMobile from "~/vue/atoms/buttons/ButtonFilterMobile.vue";
import ButtonSecondary from "~/vue/atoms/buttons/ButtonSecondary.vue";
import TextH5 from "~/vue/atoms/texts/TextH5.vue";

interface Props {
	translations?: Translations | null;
	corporate: Array<Category>;
	meeting: Array<Category>;
	report: Array<Category>;
	month: Array<Category>;
	exclude?: Array<string>;
	// insideInfo: Array<Category>
	// regulatedInfo: Array<Category>
}


export default /*@__PURE__*/_defineComponent({
  __name: 'FilterFileManager',
  props: {
    translations: { default: null },
    corporate: {},
    meeting: {},
    report: {},
    month: {},
    exclude: { default: [] }
  },
  setup(__props: any) {

const props = __props;
const fileManagerStore = useFileManagerStore();
const { documents, pagination, facets, facetsAfterFilter, loading, filters } = storeToRefs(fileManagerStore);
const mobileExpanded = ref(false);

const toggleMobile = () => {
	mobileExpanded.value = !mobileExpanded.value;
};

const createFilter = (fieldName: string, values: Array<Category>) => {
	let facet = facets.value.find((facet: Facet) => facet.field_name === fieldName);
	let facetAfterFilter = facetsAfterFilter.value.find((facet: Facet) => facet.field_name === fieldName);
	let allDisabled = false;

	if (facet) {
		facet.counts.forEach((count: FacetCount) => {
			const match = values.find((filter) => filter.slug === count.highlighted);

			if (facetAfterFilter) {
				const existsInFacetAfterFilter = facetAfterFilter.counts.find(
					(facetAfterCount) => facetAfterCount.highlighted == count.highlighted,
				);

				if (existsInFacetAfterFilter) {
					count.disabled = false;
				} else {
					count.disabled = true;
				}
			} else {
				count.disabled = true;
			}

			if (match) {
				count.value = getHtmlSpecialCharsDecode(match.title);
			}
		});

		// don't show the filter if all results are disabled
		allDisabled = facet.counts.filter((count) => count.disabled == false).length === 0;
		if (allDisabled) {
			facet = null;
		}
	}

	return facet;
};

const getFilterValues = (values: Array<string>) => {
	return values.map((value) => getGlobalTranslation(value)).join(", ");
};

const yearFilter = computed(() => {
	let filteredFacet = facets.value.find((facet: Facet) => facet.field_name === "year");
	let facetAfterFilter = facetsAfterFilter.value.find((facet: Facet) => facet.field_name === "year");
	const currentYear = new Date().getFullYear();

	if (filteredFacet) {
		filteredFacet.counts.forEach((count: FacetCount) => {
			if (facetAfterFilter) {
				const existsInFacetAfterFilter = facetAfterFilter.counts.find(
					(facetAfterCount) => facetAfterCount.highlighted == count.highlighted,
				);

				if (existsInFacetAfterFilter) {
					count.disabled = false;
				} else {
					count.disabled = true;
				}
			} else {
				count.disabled = true;
			}

			// if (count.value == currentYear) {
			//     count.value = `${getTranslation(props.translations,'Most recent')} (${new Date().getFullYear()})`
			// }
		});
	}

	return filteredFacet;
});

const filtersSelected = computed(() => {
	if (filters.value) {
		return (
			filters.value.corporate.values.length +
			filters.value.report.values.length +
			filters.value.meeting.values.length
		);
	}

	return 0;
});

const updateFacet = (facet: any) => {
	fileManagerStore.setFilter(facet.field, facet.value);
};

const updateSearch = (search: string) => {
	fileManagerStore.setSearch(search);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (createFilter('meetingType', __props.meeting) && __props.exclude.indexOf('meetingType') < 0)
          ? (_openBlock(), _createBlock(FilterMultiselect, {
              key: 0,
              label: _unref(getTranslation)(__props.translations, 'Meeting type'),
              type: "meeting",
              facet: createFilter('meetingType', __props.meeting),
              loading: _unref(loading),
              translations: __props.translations,
              selected: _unref(filters).meeting.values,
              "dropdown-position": "left",
              utilities: "grow mb-4",
              onSetFacet: _cache[0] || (_cache[0] = ($event: any) => (updateFacet($event)))
            }, null, 8, ["label", "facet", "loading", "translations", "selected"]))
          : _createCommentVNode("", true),
        (createFilter('meetingType', __props.month) && __props.exclude.indexOf('meetingType') > -1)
          ? (_openBlock(), _createBlock(FilterConsent, {
              key: 1,
              label: _unref(getTranslation)(__props.translations, 'Meeting type'),
              values: _unref(filters).meeting.values.join(', '),
              type: "meetingType",
              utilities: "w-[48%] mr-2 sm:mr-0 sm:w-auto sm:grow mb-4"
            }, null, 8, ["label", "values"]))
          : _createCommentVNode("", true),
        (createFilter('reportType', __props.report) && __props.exclude.indexOf('reportType') < 0)
          ? (_openBlock(), _createBlock(FilterMultiselect, {
              key: 2,
              label: _unref(getTranslation)(__props.translations, 'Report Type'),
              type: "report",
              facet: createFilter('reportType', __props.report),
              loading: _unref(loading),
              translations: __props.translations,
              selected: _unref(filters).report.values,
              "dropdown-position": "left",
              utilities: "w-[48%] sm:w-auto sm:grow mb-4",
              onSetFacet: _cache[1] || (_cache[1] = ($event: any) => (updateFacet($event)))
            }, null, 8, ["label", "facet", "loading", "translations", "selected"]))
          : _createCommentVNode("", true),
        (createFilter('reportType', __props.month) && __props.exclude.indexOf('reportType') > -1)
          ? (_openBlock(), _createBlock(FilterConsent, {
              key: 3,
              label: _unref(getTranslation)(__props.translations, 'Report Type'),
              values: _unref(filters).report.values.join(', '),
              type: "reportType",
              utilities: "w-[48%] mr-2 sm:mr-0 sm:w-auto sm:grow mb-4"
            }, null, 8, ["label", "values"]))
          : _createCommentVNode("", true),
        (createFilter('corporateType', __props.corporate) && __props.exclude.indexOf('corporateType') < 0)
          ? (_openBlock(), _createBlock(FilterMultiselect, {
              key: 4,
              label: _unref(getTranslation)(__props.translations, 'Corporate Type'),
              type: "corporate",
              facet: createFilter('corporateType', __props.corporate),
              loading: _unref(loading),
              translations: __props.translations,
              selected: _unref(filters).corporate.values,
              "dropdown-position": "left",
              utilities: "w-full sm:w-auto sm:grow mb-4",
              onSetFacet: _cache[2] || (_cache[2] = ($event: any) => (updateFacet($event)))
            }, null, 8, ["label", "facet", "loading", "translations", "selected"]))
          : _createCommentVNode("", true),
        (createFilter('corporateType', __props.month) && __props.exclude.indexOf('corporateType') > -1)
          ? (_openBlock(), _createBlock(FilterConsent, {
              key: 5,
              label: _unref(getTranslation)(__props.translations, 'Corporate Type'),
              values: _unref(filters).corporate.values.join(', '),
              type: "corporate",
              utilities: "w-[48%] mr-2 sm:mr-0 sm:w-auto sm:grow mb-4"
            }, null, 8, ["label", "values"]))
          : _createCommentVNode("", true),
        (yearFilter.value && __props.exclude.indexOf('year') < 0)
          ? (_openBlock(), _createBlock(FilterMultiselect, {
              key: 6,
              label: _unref(getTranslation)(__props.translations, 'Year'),
              type: "year",
              facet: yearFilter.value,
              loading: _unref(loading),
              translations: __props.translations,
              selected: _unref(filters).year.values,
              "dropdown-position": "left",
              utilities: "w-[48%] mr-2 sm:mr-0 sm:w-auto sm:grow mb-4",
              onSetFacet: _cache[3] || (_cache[3] = ($event: any) => (updateFacet($event)))
            }, null, 8, ["label", "facet", "loading", "translations", "selected"]))
          : _createCommentVNode("", true),
        (yearFilter.value && __props.exclude.indexOf('year') > -1)
          ? (_openBlock(), _createBlock(FilterConsent, {
              key: 7,
              label: _unref(getTranslation)(__props.translations, 'Year'),
              values: _unref(filters).year.values.join(', '),
              type: "year",
              utilities: "w-[48%] mr-2 sm:mr-0 sm:w-auto sm:grow mb-4"
            }, null, 8, ["label", "values"]))
          : _createCommentVNode("", true),
        (createFilter('month', __props.month) && __props.exclude.indexOf('month') < 0)
          ? (_openBlock(), _createBlock(FilterMultiselect, {
              key: 8,
              label: _unref(getGlobalTranslation)('month'),
              type: "month",
              facet: createFilter('month', __props.month),
              loading: _unref(loading),
              translations: __props.translations,
              selected: _unref(filters).month.values,
              "dropdown-position": "left",
              utilities: "grow mb-4",
              onSetFacet: _cache[4] || (_cache[4] = ($event: any) => (updateFacet($event)))
            }, null, 8, ["label", "facet", "loading", "translations", "selected"]))
          : _createCommentVNode("", true),
        (createFilter('month', __props.month) && __props.exclude.indexOf('month') > -1)
          ? (_openBlock(), _createBlock(FilterConsent, {
              key: 9,
              label: _unref(getGlobalTranslation)('month'),
              values: getFilterValues(_unref(filters).month.values),
              type: "month",
              utilities: "w-[48%] mr-2 sm:mr-0 sm:w-auto sm:grow mb-4"
            }, null, 8, ["label", "values"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(ButtonFilterMobile, {
        label: _unref(getGlobalTranslation)('Filter'),
        selected: filtersSelected.value,
        loading: _unref(loading),
        utilities: "mb-4",
        onClick: toggleMobile
      }, null, 8, ["label", "selected", "loading"]),
      (mobileExpanded.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "fixed bottom-0 left-0 z-50 block h-screen w-screen bg-black/40 md:hidden",
            onClick: toggleMobile
          }))
        : _createCommentVNode("", true),
      (mobileExpanded.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("header", _hoisted_6, [
              _createVNode(TextH5, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(getGlobalTranslation)("Filter")), 1)
                ]),
                _: 1
              }),
              _createVNode(ButtonSecondary, {
                ga: {
							category: 'filter-file-manager-mobile-toggle',
							action: 'click',
							label: _unref(getGlobalTranslation)('Close'),
						},
                icon: "times",
                size: "small",
                onClick: toggleMobile
              }, null, 8, ["ga"])
            ]),
            _createElementVNode("div", _hoisted_7, [
              (createFilter('meetingType', __props.meeting) && __props.exclude.indexOf('meetingType') < 0)
                ? (_openBlock(), _createBlock(FilterMultiselectMobile, {
                    key: 0,
                    label: _unref(getTranslation)(__props.translations, 'Meeting type'),
                    type: "meeting",
                    facet: createFilter('meetingType', __props.meeting),
                    loading: _unref(loading),
                    translations: __props.translations,
                    selected: _unref(filters).meeting.values,
                    "dropdown-position": "left",
                    utilities: "grow mb-4",
                    onSetFacet: _cache[5] || (_cache[5] = ($event: any) => (updateFacet($event)))
                  }, null, 8, ["label", "facet", "loading", "translations", "selected"]))
                : _createCommentVNode("", true),
              (createFilter('reportType', __props.report) && __props.exclude.indexOf('reportType') < 0)
                ? (_openBlock(), _createBlock(FilterMultiselectMobile, {
                    key: 1,
                    label: _unref(getTranslation)(__props.translations, 'Report Type'),
                    type: "report",
                    facet: createFilter('reportType', __props.report),
                    loading: _unref(loading),
                    translations: __props.translations,
                    selected: _unref(filters).report.values,
                    "dropdown-position": "left",
                    utilities: "w-full mb-4",
                    onSetFacet: _cache[6] || (_cache[6] = ($event: any) => (updateFacet($event)))
                  }, null, 8, ["label", "facet", "loading", "translations", "selected"]))
                : _createCommentVNode("", true),
              (createFilter('corporateType', __props.corporate) && __props.exclude.indexOf('corporateType') < 0)
                ? (_openBlock(), _createBlock(FilterMultiselectMobile, {
                    key: 2,
                    label: _unref(getTranslation)(__props.translations, 'Legal Type'),
                    type: "corporate",
                    facet: createFilter('corporateType', __props.corporate),
                    loading: _unref(loading),
                    translations: __props.translations,
                    selected: _unref(filters).corporate.values,
                    "dropdown-position": "left",
                    utilities: "w-full mb-4",
                    onSetFacet: _cache[7] || (_cache[7] = ($event: any) => (updateFacet($event)))
                  }, null, 8, ["label", "facet", "loading", "translations", "selected"]))
                : _createCommentVNode("", true),
              (yearFilter.value && __props.exclude.indexOf('year') < 0)
                ? (_openBlock(), _createBlock(FilterMultiselectMobile, {
                    key: 3,
                    label: _unref(getTranslation)(__props.translations, 'Year'),
                    type: "year",
                    facet: yearFilter.value,
                    loading: _unref(loading),
                    translations: __props.translations,
                    selected: _unref(filters).year.values,
                    "dropdown-position": "left",
                    utilities: "w-full mb-4",
                    onSetFacet: _cache[8] || (_cache[8] = ($event: any) => (updateFacet($event)))
                  }, null, 8, ["label", "facet", "loading", "translations", "selected"]))
                : _createCommentVNode("", true),
              (createFilter('month', __props.month) && __props.exclude.indexOf('month') < 0)
                ? (_openBlock(), _createBlock(FilterMultiselectMobile, {
                    key: 4,
                    label: _unref(getTranslation)(__props.translations, 'Month'),
                    type: "month",
                    facet: createFilter('month', __props.month),
                    loading: _unref(loading),
                    translations: __props.translations,
                    selected: _unref(filters).month.values,
                    "dropdown-position": "left",
                    utilities: "w-full mb-4",
                    onSetFacet: _cache[9] || (_cache[9] = ($event: any) => (updateFacet($event)))
                  }, null, 8, ["label", "facet", "loading", "translations", "selected"]))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(FilterSearch, {
      label: _unref(getGlobalTranslation)('Search for something specific'),
      type: "searchQuery",
      loading: _unref(loading),
      translations: __props.translations,
      utilities: "mb-4",
      onSetQuery: _cache[10] || (_cache[10] = ($event: any) => (updateSearch($event)))
    }, null, 8, ["label", "loading", "translations"])
  ]))
}
}

})